document.addEventListener("DOMContentLoaded", () => {
  const loadMoreBtn = document.querySelector("#load-more");
  if (!loadMoreBtn) return;

  const productGrid = document.querySelector("#product-grid");

  // Track seen products (avoid duplicates)
  const seen = new Set(
    Array.from(productGrid.querySelectorAll("[data-product-id], a"))
      .map(el => el.getAttribute("data-product-id") || el.getAttribute("href"))
  );

  const loadProducts = async () => {
    let nextUrl = loadMoreBtn.getAttribute("data-next-url");
    if (!nextUrl) return;

    loadMoreBtn.innerText = "Loading...";

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(text, "text/html");

      const newProducts = htmlDoc.querySelectorAll("#product-grid > *");

      newProducts.forEach(product => {
        const pid =
          product.getAttribute("data-product-id") ||
          product.querySelector("a")?.getAttribute("href") ||
          product.innerHTML.slice(0, 100);

        if (!seen.has(pid)) {
          productGrid.appendChild(product);
          seen.add(pid);
        }
      });

      const newNextBtn = htmlDoc.querySelector("#load-more");
      if (newNextBtn) {
        loadMoreBtn.setAttribute("data-next-url", newNextBtn.getAttribute("data-next-url"));
        loadMoreBtn.innerText = "Load More";
      } else {
        observer.disconnect(); // stop observing
        loadMoreBtn.remove();
      }
    } catch (err) {
      console.error(err);
      loadMoreBtn.innerText = "Error! Try again";
    }
  };

  // IntersectionObserver → auto load before footer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadProducts();
        }
      });
    },
    { rootMargin: "800px" } // load when 800px before button is visible
  );

  observer.observe(loadMoreBtn);

  // Manual click fallback
  loadMoreBtn.addEventListener("click", loadProducts);
});